import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: number[] = []

const lostShoppers = createSlice({
  name: 'lostShoppers',
  initialState,
  reducers: {
    addRetailerLostShoppers(state, action: PayloadAction<number>) {
      if (state.indexOf(action.payload) === -1) state.push(action.payload)
      return state
    },
  },
})

export const { addRetailerLostShoppers } = lostShoppers.actions

export default lostShoppers.reducer
